// @ts-ignore
import throttle from 'lodash/throttle';
import {Utils} from "./Utils";
export class MegaMenu {
  wrapper: HTMLElement;
  submenuWrapper: HTMLElement;
  submenuWrapperHeight: number = 0;
  submenuOpenButton: NodeListOf<HTMLElement>;
  submenuCloseButton: NodeListOf<HTMLElement>;
  sectionMenu: HTMLElement|undefined;
  pageOverlay: HTMLElement|undefined;
  submenus: NodeListOf<HTMLElement>;
  subnavs: NodeListOf<HTMLElement>;
  subnavTriggers: NodeListOf<HTMLElement>;

  currentNavs: NodeListOf<HTMLElement>;
  currentFirstLevelHeight: number = 0;

  constructor() {
    this.wrapper = document.querySelector('[data-mainmenu-wrapper]');
    if (!this.wrapper) {
      return;
    }

    this.submenuWrapper = this.wrapper.querySelector('[data-submenu-wrapper]');
    if (!this.submenuWrapper) {
      return;
    }

    this.resetHeight();
    this.submenuWrapperHeight = this.submenuWrapper.getBoundingClientRect().height;

    this.submenuOpenButton = this.wrapper.querySelectorAll('[data-submenu-open]');
    this.submenuCloseButton = this.wrapper.querySelectorAll('[data-submenu-close]');
    this.submenus = this.wrapper.querySelectorAll('[data-submenu]');
    this.subnavs = this.wrapper.querySelectorAll('[data-submenu-nav]');
    this.subnavTriggers = this.wrapper.querySelectorAll('[data-submenu-nav-trigger]');

    this.sectionMenu = document.querySelector('.c-section-menu');
    this.pageOverlay = document.querySelector('.o-page__overlay');

    this.currentNavs = this.wrapper.querySelectorAll('[data-submenu-nav].is-current');

    this.submenuOpenButton.forEach(button => {
      const key = button.getAttribute('data-submenu-open');
      if (key) {
        const submenu: HTMLElement = this.wrapper.querySelector(`[data-submenu="${key}"]`);
        const subnav: HTMLElement = this.wrapper.querySelector(`[data-submenu-nav="${key}"]`);
        button.addEventListener('click', () => {
          if (submenu && submenu.classList.contains('is-active')) {
            return;
          }
          this.closeSubmenu();
          this.openSubmenu(submenu, subnav, button);
        });
      }
    });

    this.submenuCloseButton.forEach(button => {
      button.addEventListener('click', () => {
        this.closeSubmenu();
      });
    });

    this.subnavTriggers.forEach(button => {
      const key = button.getAttribute('data-submenu-nav-trigger');
      if (key) {
        const subnav: HTMLElement = this.wrapper.querySelector(`[data-submenu-nav="${key}"]`);
        const parentSubnav = subnav?.parentElement?.closest('[data-submenu-nav]');
        let closingSubnavs: NodeListOf<HTMLElement> = parentSubnav?.querySelectorAll('[data-submenu-nav]');
        if (!parentSubnav) {
          closingSubnavs = subnav?.querySelectorAll('[data-submenu-nav]');
        }
        button.addEventListener('click', () => {
          if (closingSubnavs) {
            closingSubnavs.forEach(item => {
              item.classList.remove('is-active')
            });
          }
          subnav?.classList.add('is-active');
          this.updateHeight();
        });
      }
    });

    this.pageOverlay?.addEventListener('click', () => {
      this.closeSubmenu();
    })

    window.addEventListener('resize', throttle(() => {
      if (window.innerWidth < 1008) {
        this.closeSubmenu();
      }
    }, 200));
  }

  closeSubmenu() {
    this.resetHeight();
    this.currentFirstLevelHeight = 0;
    this.submenuWrapper.style.height = null;
    this.submenuWrapper.classList.remove('is-active');
    this.submenus.forEach(item => {
      item.classList.remove('is-active');
      item.style.height = null;
    });
    this.subnavs.forEach(item => {
      item.classList.remove('is-active');
    });
    this.submenuOpenButton.forEach(button => {
      button.classList.remove('is-active');
    });
    this.hideBackgroundOverlay();
  }

  openSubmenu(submenu: HTMLElement|undefined, subnav: HTMLElement|undefined, button: HTMLElement|undefined) {
    this.showBackgroundOverlay();

    this.submenuWrapper.classList.add('is-active');
    if (button) {
      button.classList.add('is-active');
      if (button.classList.contains('is-current')) {
        this.openCurrentNav();
      }
    }
    if (submenu) {
      submenu.classList.add('is-active');
    }
    if (subnav) {
      subnav.classList.add('is-active');
      this.currentFirstLevelHeight = subnav.getBoundingClientRect().height;
    }
    this.updateHeight();
  }

  openCurrentNav() {
    this.currentNavs.forEach(nav => {
      nav.classList.add('is-active');
      this.updateHeight();
    });
  }

  updateHeight() {
    const navs = this.wrapper.querySelectorAll('[data-submenu-nav].is-active');
    let height = this.currentFirstLevelHeight;
    navs.forEach(nav => {
      if (navs.length > 1 && nav.classList.contains('c-mainmenu__sub-nav--level-1')) {
        return;
      }
      const newHeight = nav.getBoundingClientRect().height;
      if (height < newHeight && this.currentFirstLevelHeight <= newHeight) {
        height = newHeight;
      }
    });
    this.wrapper.style.setProperty('--submenu-height', height + 'px');
  }

  resetHeight() {
    this.wrapper.style.setProperty('--submenu-height', '0px');
  }

  showBackgroundOverlay() {
    if (this.pageOverlay) {
      this.pageOverlay.classList.add('o-page__overlay--for-mainmenu');
      if (this.sectionMenu) {
        this.sectionMenu.style.zIndex = '1030';
      }
    }
  }

  hideBackgroundOverlay() {
    if (this.pageOverlay) {
      this.pageOverlay.classList.remove('o-page__overlay--for-mainmenu');
      if (this.sectionMenu) {
        this.sectionMenu.style.zIndex = '10';
      }
    }
  }
}

Utils.executeWhenDocumentIsReady( () => {
  new MegaMenu();
});
